import React from "react";
import { Button, Modal } from "antd";

export default function ModalAlert({ info }) {
  return (
    info && (
      <Modal
        visible={info.visible}
        footer={null}
        closable={false}
        maskClosable={false}
        wrapClassName="modal-custom-info modal-custom-alert"
      >
        <div className="modal-custom-info-content">
          <em className={`fal ${info.icon}`} style={{color: info.iconColor}} />
          <h1>{info.title}</h1>
          <p style={{ marginBottom: "10px", fontSize:'18px', textAlign: info.textAlign ? info.textAlign : 'center' }}>{info.description}</p>
          {info.info && <h1 className="ant-typography" style={{ alignSelf: "flex-start", fontSize:'1.6rem' }}>
            {info.info}
          </h1>}
          <div >
            <Button className="ant-btn-outline c-2 ant-btn-size-xs" onClick={info.onConfirm}>
              {info.buttonText}
            </Button>
          </div>
        </div>
      </Modal>
    )
  );
}
